/**
 * 提交表单
 */
import * as React from 'react'
import { Form, AutoComplete, message } from 'antd'
import debounce from 'lodash/debounce'
import { useTranslation } from '@/libs/next-lang'
import useCompanyNameSearch from '@/hooks/useCompanyNameSearch'
import { companyTagSave } from '@/services/user'
import styles from './index.module.less'

const FormItem = Form.Item

const { useState, useRef } = React

export default function Content({ form, isPersonal, onOk, onClose }: any) {
  const [loaded, setLoaded] = useState(false)
  const confirmRef = useRef<boolean>(false)

  const { t } = useTranslation(['components'])

  const { open, companyNameList, onVisible, onSearch, onChange } = useCompanyNameSearch()

  /**
   * 关闭
   */
  const handleClose = () => {
    onClose?.()
    onOk?.()
  }

  /**
   * 个人领取提交
   */
  const handleOk = () => {
    form.validateFields().then(async ({ companyName }: any) => {
      if (confirmRef.current) {
        return
      }
      if (!companyName?.trim()) {
        message.warning(t('components:t109'))
        return
      }
      confirmRef.current = true
      try {
        const { data = {} } = await companyTagSave({ companyName })
        if (data?.code === 0) {
          message.success(t('components:t110'))
          handleClose()
        }
      } finally {
        confirmRef.current = false
      }
    })
  }

  const renderForm = () => {
    if (isPersonal) {
      const debounceSearch = debounce(onSearch, 800)
      return (
        <>
          <img
            draggable={false}
            className={styles.img}
            src="https://static.creativebooster.com/landing/gtm/gift_bg_p.png?x-oss-process=imageformat,webp"
            alt="personal"
            onLoad={() => setLoaded(true)}
          />
          {loaded && (
            <div className={styles.main} style={{ bottom: 20 }}>
              <div className={styles.content}>
                <h3 className={styles['title-1']}>{t('components:t120')}</h3>
              </div>
              <div className={styles.form}>
                <FormItem name="companyName" noStyle>
                  <AutoComplete
                    popupClassName={styles['auto-complete-dropdown']}
                    style={{ width: '100%', marginBottom: 30 }}
                    maxLength={200}
                    placeholder={t('components:t121')}
                    open={open}
                    options={companyNameList}
                    onSearch={debounceSearch}
                    onChange={onChange}
                    onDropdownVisibleChange={onVisible}
                  />
                </FormItem>
                <div style={{ marginBottom: 20 }} className={styles.btn} onClick={handleOk}>
                  {t('components:t122')}
                </div>
                <div className={styles.footer}>
                  <div className={styles['btn-2']} onClick={handleClose}>
                    {t('components:t123')}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )
    }
    return (
      <>
        <img
          draggable={false}
          className={styles.img}
          src="https://static.creativebooster.com/landing/gtm/gift_bg_p.png?x-oss-process=image/format,webp"
          alt="team"
          onLoad={() => setLoaded(true)}
        />

        {loaded && (
          <div className={styles.main}>
            <div className={styles.content}>
              <h3 className={styles['title-2']}>{t('components:t124')}</h3>
              <h4 className={styles.subtitle}>{t('components:t111')}</h4>
            </div>
            <div className={styles.form}>
              <div className={styles.btn} onClick={() => onClose?.()}>
                {t('components:t122')}
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
  return <div className={styles.gift}>{renderForm()}</div>
}
